export default __webpack_public_path__ + "images/ca16befd472a0bf82c41cf3fe9291ee7.svg";